import { render } from "./ecosystemPage.vue?vue&type=template&id=77d69612"
import script from "./ecosystemPage.vue?vue&type=script&lang=js"
export * from "./ecosystemPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__